"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByProductEdge_1 = __importDefault(require("../entity/SalesByProductEdge"));
const SalesByProductDataStub_1 = __importDefault(require("./SalesByProductDataStub"));
class SalesByProductEdgeStub extends SalesByProductEdge_1.default {
    constructor({ cursor = 'Test', node = new SalesByProductDataStub_1.default() } = {}) {
        super({ cursor, node });
    }
}
exports.default = SalesByProductEdgeStub;
